import {Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DebtsService} from "../../../models/debts/debts.service";
import {CloseReasonsModel} from "../../../models/debts/debts.model";

@Component({
    selector: 'close-debt-account-modal',
    templateUrl: 'close-debt-account.template.html',
    styleUrls: []
})

export class CloseDebtAccountModalComponent implements OnInit, AfterViewInit {
    
    public accountId: number;
    public reason: number;

    public reasons;

    constructor(
        public activeModal: NgbActiveModal,
        private debtsService: DebtsService) {

    }

    ngOnInit() {
        this.reasons = CloseReasonsModel.reasons;
    }

    ngAfterViewInit() {

    }

    closeAccount() {
        this.activeModal.close(this.reason);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/debt-account/close-debt-account/close-debt-account.component.ts